var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "transition",
    {
      attrs: { name: "modal" },
      on: {
        "before-enter": _vm.onBeforeEnter,
        "after-leave": _vm.onAfterLeave,
      },
    },
    [
      _vm.isVisible
        ? _c(
            "div",
            {
              class: [
                "holiday-search-modal-overlay",
                { "d-flex": _vm.isVisible },
                { "active-search": _vm.isDropdownOrAutoCompleteOpen },
              ],
            },
            [
              _c(
                "div",
                {
                  staticClass: "holiday-search-modal-intro",
                  on: { click: _vm.closeModal },
                },
                [
                  _c("div", { staticClass: "container-fluid" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col" }, [
                        _c("picture", [
                          _c("img", {
                            staticClass: "holiday-search-modal-logo",
                            attrs: {
                              src: `${_vm.logo}?format=webp`,
                              alt: _vm.logoAlt,
                              loading: "lazy",
                            },
                          }),
                        ]),
                      ]),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "container" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col" }, [
                    _c("div", { staticClass: "holiday-search-modal" }, [
                      _c(
                        "button",
                        {
                          staticClass: "close-button",
                          attrs: {
                            "aria-label": "Close the modal",
                            title: "Close the modal",
                          },
                          on: { click: _vm.closeModal },
                        },
                        [
                          _c("span", [_vm._v("close")]),
                          _vm._v(" "),
                          _c(
                            "svg",
                            {
                              attrs: {
                                id: "Close",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 14 14",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  id: "Path_4605",
                                  "data-name": "Path 4605",
                                  d: "M12.3,13.7.3,1.7A.967.967,0,0,1,.3.3h0A.967.967,0,0,1,1.7.3l12,12a.967.967,0,0,1,0,1.4h0A.967.967,0,0,1,12.3,13.7Z",
                                  fill: "#A9378C",
                                },
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  id: "Path_4606",
                                  "data-name": "Path 4606",
                                  d: "M.3,12.3l12-12a.967.967,0,0,1,1.4,0h0a.967.967,0,0,1,0,1.4l-12,12a.967.967,0,0,1-1.4,0h0A.967.967,0,0,1,.3,12.3Z",
                                  fill: "#A9378C",
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "holiday-search-modal-content" },
                        [
                          _c("holiday-search", {
                            attrs: {
                              action: _vm.action,
                              "auto-complete-url": _vm.autoCompleteUrl,
                              "show-departure-filter": _vm.showDepartureFilter,
                              "where-name": _vm.whereName,
                              "where-description": _vm.whereDescription,
                              "onclick-placeholder": _vm.onclickPlaceholder,
                              "when-name": _vm.whenName,
                              "when-description": _vm.whenDescription,
                              "how-name": _vm.howName,
                              "travel-style-description":
                                _vm.travelStyleDescription,
                              "departure-description": _vm.departureDescription,
                            },
                            on: {
                              "toggle-open": _vm.setDropdownOrAutoCompleteOpen,
                            },
                          }),
                          _vm._v(" "),
                          _vm._t("default"),
                        ],
                        2
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }